module.exports = __webpack_public_path__ + "img/ic_benifit_pk.7c3f6e0c.png";